module.exports = __webpack_public_path__ + "static/media/om_eyeshape_monolid_blue.cf9cb1e9.png";